var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowCircleUp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0999 12C21.0999 17.0258 17.0257 21.1 11.9999 21.1C6.97411 21.1 2.8999 17.0258 2.8999 12C2.8999 6.9742 6.97411 2.89999 11.9999 2.89999C17.0257 2.89999 21.0999 6.9742 21.0999 12ZM16.802 10.7979L13.202 7.19791C12.5381 6.53402 11.4617 6.53402 10.7978 7.19791L7.19782 10.7979C6.53393 11.4618 6.53393 12.5382 7.19782 13.2021C7.86171 13.866 8.93809 13.866 9.60198 13.2021L10.2999 12.5042L10.2999 15.6C10.2999 16.5389 11.061 17.3 11.9999 17.3C12.9388 17.3 13.6999 16.5389 13.6999 15.6V12.5042L14.3978 13.2021C15.0617 13.866 16.1381 13.866 16.802 13.2021C17.4659 12.5382 17.4659 11.4618 16.802 10.7979Z",
    fill: "currentColor",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircleUp);
export default __webpack_public_path__ + "static/media/arrow-circle-up.8977d94ba2239057669e1745c3411590.svg";
export { ForwardRef as ReactComponent };